let bundleUpdateInProgress = false;

class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", (event) => {
            event.preventDefault();
            const cartItems =
                this.closest("cart-items") || this.closest("cart-drawer-items");
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();

        this.lineItemStatusElement =
            document.getElementById("shopping-cart-line-item-status") ||
            document.getElementById("CartDrawer-LineItemStatus");

        this.currentItemCount = Array.from(
            this.querySelectorAll('[name="updates[]"]')
        ).reduce(
            (total, quantityInput) => total + parseInt(quantityInput.value),
            0
        );

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener("change", this.debouncedOnChange.bind(this));
    }

    onChange(event) {
        this.updateQuantity(
            event.target.dataset.index,
            event.target.value,
            document.activeElement.getAttribute("name")
        );
    }

    getSectionsToRender() {
        return [
            {
                id: "main-cart-items",
                section: document.getElementById("main-cart-items").dataset.id,
                selector: ".js-contents",
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
            },
            {
                id: "cart-live-region-text",
                section: "cart-live-region-text",
                selector: ".shopify-section",
            },
            {
                id: "main-cart-footer",
                section: document.getElementById("main-cart-footer").dataset.id,
                selector: ".js-contents",
            },
        ];
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map(
                (section) => section.section
            ),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.classList.toggle("is-empty", parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector("cart-drawer");
                const cartFooter = document.getElementById("main-cart-footer");

                if (cartFooter)
                    cartFooter.classList.toggle(
                        "is-empty",
                        parsedState.item_count === 0
                    );
                if (cartDrawerWrapper)
                    cartDrawerWrapper.classList.toggle(
                        "is-empty",
                        parsedState.item_count === 0
                    );

                const sectionsToRender = this.getSectionsToRender();
                sectionsToRender.forEach((section, i) => {
                    const elementToReplace =
                        document
                            .getElementById(section.id)
                            .querySelector(section.selector) ||
                        document.getElementById(section.id);

                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector
                    );

                    if (i === sectionsToRender.length - 1) {
                        // window.minicartUpsell.reInit(parsedState); 
                    }
                });

                this.updateLiveRegions(line, parsedState.item_count);

                const lineItem =
                    document.getElementById(`CartItem-${line}`) ||
                    document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper
                        ? trapFocus(
                              cartDrawerWrapper,
                              lineItem.querySelector(`[name="${name}"]`)
                          )
                        : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(
                        cartDrawerWrapper.querySelector(".drawer__inner-empty"),
                        cartDrawerWrapper.querySelector("a")
                    );
                } else if (
                    document.querySelector(".cart-item") &&
                    cartDrawerWrapper
                ) {
                    trapFocus(
                        cartDrawerWrapper,
                        document.querySelector(".cart-item__name")
                    );
                }
                this.disableLoading();
            })
            .catch(() => {
                this.querySelectorAll(".loading-overlay").forEach((overlay) =>
                    overlay.classList.add("hidden")
                );
                const errors =
                    document.getElementById("cart-errors") ||
                    document.getElementById("CartDrawer-CartErrors");
                errors.textContent = window.cartStrings.error;
                this.disableLoading();
            });
    }

    updateProperties(line, properties, name) {
        this.enableLoading(line);

        const body = JSON.stringify({
            line,
            properties,
            sections: this.getSectionsToRender().map(
                (section) => section.section
            ),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.classList.toggle("is-empty", parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector("cart-drawer");
                const cartFooter = document.getElementById("main-cart-footer");

                if (cartFooter)
                    cartFooter.classList.toggle(
                        "is-empty",
                        parsedState.item_count === 0
                    );
                if (cartDrawerWrapper)
                    cartDrawerWrapper.classList.toggle(
                        "is-empty",
                        parsedState.item_count === 0
                    );

                const sectionsToRender = this.getSectionsToRender();
                sectionsToRender.forEach((section, i) => {
                    const elementToReplace =
                        document
                            .getElementById(section.id)
                            .querySelector(section.selector) ||
                        document.getElementById(section.id);

                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector
                    );

                    if (i === sectionsToRender.length - 1) {
                        // window.minicartUpsell.reInit(parsedState);
                    }
                });

                this.updateLiveRegions(line, parsedState.item_count);

                const lineItem =
                    document.getElementById(`CartItem-${line}`) ||
                    document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper
                        ? trapFocus(
                            cartDrawerWrapper,
                            lineItem.querySelector(`[name="${name}"]`)
                        )
                        : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(
                        cartDrawerWrapper.querySelector(".drawer__inner-empty"),
                        cartDrawerWrapper.querySelector("a")
                    );
                } else if (
                    document.querySelector(".cart-item") &&
                    cartDrawerWrapper
                ) {
                    trapFocus(
                        cartDrawerWrapper,
                        document.querySelector(".cart-item__name")
                    );
                }
                this.disableLoading();
            })
            .catch(() => {
                this.querySelectorAll(".loading-overlay").forEach((overlay) =>
                    overlay.classList.add("hidden")
                );
                const errors =
                    document.getElementById("cart-errors") ||
                    document.getElementById("CartDrawer-CartErrors");
                errors.textContent = window.cartStrings.error;
                this.disableLoading();
            });
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            const lineItemError =
                document.getElementById(`Line-item-error-${line}`) ||
                document.getElementById(`CartDrawer-LineItemError-${line}`);
            const quantityElement =
                document.getElementById(`Quantity-${line}`) ||
                document.getElementById(`Drawer-quantity-${line}`);

            lineItemError.querySelector(".cart-item__error-text").innerHTML =
                window.cartStrings.quantityError.replace(
                    "[quantity]",
                    quantityElement.value
                );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute("aria-hidden", true);

        const cartStatus =
            document.getElementById("cart-live-region-text") ||
            document.getElementById("CartDrawer-LiveRegionText");
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems =
            document.getElementById("main-cart-items") ||
            document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.add("cart__items--disabled");

        const cartItemElements = this.querySelectorAll(
            `#CartItem-${line} .loading-overlay`
        );
        const cartDrawerItemElements = this.querySelectorAll(
            `#CartDrawer-Item-${line} .loading-overlay`
        );

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
            overlay.classList.remove("hidden")
        );

        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }

    disableLoading() {
        const mainCartItems =
            document.getElementById("main-cart-items") ||
            document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.remove("cart__items--disabled");
    }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
    customElements.define(
        "cart-note",
        class CartNote extends HTMLElement {
            constructor() {
                super();

                this.addEventListener(
                    "change",
                    debounce((event) => {
                        const body = JSON.stringify({
                            note: event.target.value,
                        });
                        fetch(`${routes.cart_update_url}`, {
                            ...fetchConfig(),
                            ...{ body },
                        });
                    }, 300)
                );
            }
        }
    );
}






// 🔧 Reusable function: Calculate adjusted cart count (subtracting giftbox pack numbers)
function calculateAdjustedCartCount(cartItems, baseItemCount) {
  if (!cartItems || !Array.isArray(cartItems)) {
    return baseItemCount || 0;
  }

  let giftboxSubtraction = 0;
  cartItems.forEach(item => {
    const itemTitle = (item.title || item.product_title || '').toLowerCase();
    if (itemTitle.includes('giftbox') || itemTitle.includes('gift set') || itemTitle.includes('build your')) {
      let packNumber = 0;
      if (itemTitle.includes('3 pack') || itemTitle.includes('3-pack')) {
        packNumber = 3;
      } else if (itemTitle.includes('5 pack') || itemTitle.includes('5-pack')) {
        packNumber = 5;
      }
      if (packNumber > 0) {
        giftboxSubtraction += packNumber * (item.quantity || 1);
      }
    }
  });
  
  return Math.max(0, (baseItemCount || 0) - giftboxSubtraction);
}

// 🔧 Reusable function: Update drawer header item count text (with giftbox adjustment)
function updateDrawerHeaderCount(cartJson) {
  const headerCount = document.querySelector(".drawer__heading--items");
  if (!headerCount || !cartJson) return;

  const baseCount = cartJson.item_count || 0;
  const adjustedCount = calculateAdjustedCartCount(cartJson.items, baseCount);
  
  headerCount.textContent = `${adjustedCount} ${adjustedCount === 1 ? "item" : "items"}`;
}

function getRoot() {
  const raw = window?.Shopify?.routes?.root;
  if (typeof raw === "string") return raw.replace(/^"+|"+$/g, "") || "/";
  return "/";
}

async function refreshCartDrawer() {
  try {
    const sections = ["cart-drawer", "cart-icon-bubble", "main-cart-footer"];
    const url = `${getRoot()}?sections=${sections.join(",")}`;
    const res = await fetch(url);

    if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
    const html = await res.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) return;

    // 🧱 1. Rebuild section HTML map
    const parsedState = { sections: {} };
    for (const section of sections) {
      const el = doc.querySelector(`#${section}`);
      if (el) parsedState.sections[section] = el.outerHTML;
    }

    // 🧩 2. Re-render drawer contents
    cartDrawer.renderContents(parsedState);

    // 💬 3. Update header bubble (cart icon)
    const newBubble = doc.querySelector("#cart-icon-bubble");
    const currentBubble = document.querySelector("#cart-icon-bubble");
    if (newBubble && currentBubble) {
      currentBubble.innerHTML = newBubble.innerHTML;
    }

    // 💰 4. Update checkout button total
    const newTotal = doc.querySelector("#CartDrawer-Checkout");
    const checkoutButton = document.querySelector("#CartDrawer-Checkout");
    if (newTotal && checkoutButton) {
      checkoutButton.innerHTML = newTotal.innerHTML;
    }

    // 💵 5. Update "You are saving..." message
    const newSavings = doc.querySelector(".cart-total-savings");
    const oldSavings = document.querySelector(".cart-total-savings");
    if (newSavings && oldSavings) {
      oldSavings.innerHTML = newSavings.innerHTML;
    } else if (!newSavings && oldSavings) {
      oldSavings.remove();
    }

    // Small pause before checking cart state (avoid flicker)
    await new Promise((r) => setTimeout(r, 300));

    // 🛒 6. Refresh actual cart data from /cart.js
    let cartJson = null;
    try {
      const resCart = await fetch("/cart.js");
      cartJson = await resCart.json();
      window.Shopify = window.Shopify || {};
      window.Shopify.cart = cartJson;
    } catch (err) {
      console.warn("⚠️ Could not refresh window.Shopify.cart", err);
    }

    // 🧮 7. Determine if cart is empty
    const isEmpty = !cartJson || cartJson.item_count === 0;

    // 🧹 8. Toggle empty states properly
    cartDrawer.classList.toggle("is-empty", isEmpty);

    const drawerInnerContainer = document.querySelector(".cart-drawer-items-container");
    if (drawerInnerContainer) drawerInnerContainer.classList.toggle("is-empty", isEmpty);

    const footer = document.getElementById("main-cart-footer");
    if (footer) footer.classList.toggle("is-empty", isEmpty);

    // 🧾 9. Update drawer header item count text (with giftbox adjustment)
    updateDrawerHeaderCount(cartJson);

    console.log("✅ Cart drawer fully refreshed (totals + counts + state synced)");
  } catch (err) {
    console.error("🛒 refreshCartDrawer error:", err);
  }
}


// 🔧 Helper: remove all items belonging to a bundle
async function changeBundleQuantity(bundleKey, quantity) {
  if (!bundleKey) return;

  try {
    // Fetch current cart state
    const res = await fetch("/cart.js");
    const cart = await res.json();

    // Find all line indexes that belong to this bundle
    const bundleLines = cart.items
      .map((item, idx) => {
        if (item.properties && item.properties._BundleKey === bundleKey) {
          return idx + 1; // Shopify line numbers are 1-based
        }
        return null;
      })
      .filter((n) => n);

    if (!bundleLines.length) {
      console.warn(`⚠️ No items found with bundle key: ${bundleKey}`);
      return;
    }

    // Remove each item in the bundle
    for (const line of bundleLines) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line, quantity }),
      });
    }

    console.log(`✅ Removed all items from bundle: ${bundleKey}`);
  } catch (err) {
    console.error("❌ changeBundleQuantity failed:", err);
  }
}




// --- Remove pack button handler ---
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".cart-bundle__remove");
  if (!btn || bundleUpdateInProgress) return;

  const bundleKey = btn.dataset.bundleKey;
  if (!bundleKey) return;

  const drawer = document.getElementById("CartDrawer");
  bundleUpdateInProgress = true;

  // 🔒 lock drawer and show persistent spinner
  // showCartDrawerSpinner(drawer);

  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = "Removing...";

  try {
    await removeBundleSingleCall(bundleKey);
   // await refreshCartDrawer(); // ensure final state sync
  } catch (err) {
    console.error("❌ Bundle removal failed:", err);
  } finally {
    // 🧹 always clean up after operation
    // hideCartDrawerSpinner(drawer);
    btn.disabled = false;
    btn.textContent = originalText;
    bundleUpdateInProgress = false;
  }
});


// --- Bundle removal logic ---
async function removeBundle(bundleKey) {
  if (!bundleKey) return;

  console.log(`🧱 Removing bundle: ${bundleKey}`);

  try {
    let cartItemsEl = document.querySelector("cart-items, cart-drawer-items");

    // helper fetch
    const fetchCart = async () => {
      const res = await fetch("/cart.js");
      if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
      return await res.json();
    };

    while (true) {
      const cart = await fetchCart();

      const bundleLine = cart.items.findIndex(
        (it) =>
          it?.properties?._GiftSet === "true" &&
          it?.properties?._BundleKey === bundleKey
      );

      if (bundleLine === -1) break;

      const lineIndex = bundleLine + 1;
      console.log(`🗑️ Removing line ${lineIndex} for bundle ${bundleKey}`);

      if (cartItemsEl?.updateQuantity) {
        await cartItemsEl.updateQuantity(lineIndex, 0);
      } else {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: lineIndex, quantity: 0 }),
        });
      }

      // wait for Shopify DOM update
      await new Promise(r => setTimeout(r, 900));

      // ensure element re-appears
      let retry = 0;
      while (!document.querySelector("cart-items, cart-drawer-items") && retry < 10) {
        await new Promise(r => setTimeout(r, 200));
        retry++;
      }
      cartItemsEl = document.querySelector("cart-items, cart-drawer-items");
    }

    console.log(`✅ All bundle items removed for key: ${bundleKey}`);
  } catch (err) {
    console.error("❌ removeBundle failed:", err);
  }
}


// --- Bundle removal logic on a single call  ---
async function removeBundleSingleCall(bundleKey) {
  if (!bundleKey) return;

  console.log(`🧱 Removing bundle: ${bundleKey}`);
  const cartEl = document.querySelector("cart-drawer");

  try {
    let cartItemsEl = document.querySelector("cart-items, cart-drawer-items");
  
    // helper fetch
    const fetchCart = async () => {
      const res = await fetch("/cart.js");
      if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
      return await res.json();
    };
  
    // fetch cart once
    const cart = await fetchCart();
  
    // collect all bundle lines for this bundleKey
    const updates = {};
    let firstBundleLine = null;
    cart.items.forEach((item, index) => {
      const isBundleItem =
        item?.properties?._GiftSet === "true" &&
        item?.properties?._BundleKey === bundleKey;

      if (isBundleItem) {
        updates[item.key] = 0;
        // Store the first bundle item's line number (1-based)
        if (firstBundleLine === null) {
          firstBundleLine = index + 1;
        }
      }
    });

    if (Object.keys(updates).length === 0) {
      console.log(`❌ No bundle items found for key: ${bundleKey}`);
      return;
    }

    // Enable loading state
    if (cartItemsEl && typeof cartItemsEl.enableLoading === "function" && firstBundleLine) {
      cartItemsEl.enableLoading(firstBundleLine);
    }

    console.log("🗑️ Removing all bundle items in one call:", updates);
    const formData = {
      sections: cartEl?.getSectionsToRender?.().map(section => section.id) || [],
      updates,
    };

    // single bulk request
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    }).then(res => res.json());

    // 🧩 Ensure response has sections before render
    if (cartEl) {
      if (response?.sections) {
        cartEl.renderContents(response);
        console.log("✅ Cart contents rendered successfully.");
      } else {
        console.warn("⚠️ No sections found in response — retrying fetch...");
        const state = await (
          await fetch("/?sections=cart-drawer,cart-icon-bubble")
        ).json();
        cartEl.renderContents({ sections: state });
        console.log("✅ Cart contents rendered after retry.");
      }
    }

    // Update empty state classes
    const parsedState = response;
    const cartDrawerWrapper = document.querySelector("cart-drawer");
    const cartFooter = document.getElementById("main-cart-footer");
    
    // Re-query cartItemsEl in case it was re-rendered
    cartItemsEl = document.querySelector("cart-items, cart-drawer-items");

    if (cartItemsEl && parsedState.item_count !== undefined) {
      cartItemsEl.classList.toggle("is-empty", parsedState.item_count === 0);
    }

    if (cartFooter && parsedState.item_count !== undefined) {
      cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
    }

    if (cartDrawerWrapper && parsedState.item_count !== undefined) {
      cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);
    }

    // Disable loading if cartItemsEl exists
    if (cartItemsEl && typeof cartItemsEl.disableLoading === "function") {
      cartItemsEl.disableLoading();
    }

    // 🧾 Update drawer header item count text (with giftbox adjustment)
    // Use response data directly (no need to fetch /cart.js again)
    if (response && (response.items || response.item_count !== undefined)) {
      updateDrawerHeaderCount({
        items: response.items,
        item_count: response.item_count
      });
    }

    console.log(`✅ All bundle items removed for key: ${bundleKey}`);
  } catch (err) {
    console.error("❌ removeBundleSingleCall failed:", err);
  }
}
  



// === Spinner overlay helpers ===
function showCartDrawerSpinner(drawer) {
  if (!drawer) return;

  let overlay = drawer.querySelector(".drawer-loading-overlay");

  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "drawer-loading-overlay";
    overlay.innerHTML = `
      <div class="drawer-spinner"></div>
      <div class="drawer-loading-text">Updating cart...</div>
    `;
    drawer.appendChild(overlay);
  }

  overlay.classList.add("visible");

  // Disable interactions
  drawer.style.pointerEvents = "none";
  drawer.style.opacity = "1";
}

function hideCartDrawerSpinner(drawer) {
  if (!drawer) return;

  const overlay = drawer.querySelector(".drawer-loading-overlay");
  if (overlay) overlay.remove();

  drawer.style.pointerEvents = "";
  drawer.style.opacity = "";
}

